import type { NamespaceSchema } from './types';

export const bookingSettings: NamespaceSchema = {
  namespace: 'booking-settings',
  label: 'Booking rules',
  description: 'Defaults applied across the booking flow when a Car listing does not override.',
  sections: [
    {
      label: 'Checkout',
      fields: [
        { kind: 'boolean', key: 'guest_checkout', label: 'Allow guest checkout', default: true, description: 'Off = customers must log in before paying.' },
        { kind: 'boolean', key: 'enable_recaptcha', label: 'reCAPTCHA on booking form', default: false },
        { kind: 'textarea', key: 'term_conditions', label: 'Terms & conditions', rows: 4, description: 'Shown on the checkout page and the confirmation email.' },
      ],
    },
    {
      label: 'Window',
      fields: [
        { kind: 'number', key: 'min_day_before_booking', label: 'Min days in advance', min: 0, max: 365, description: 'How far ahead a booking must be placed.' },
        { kind: 'number', key: 'max_day_before_booking', label: 'Max days in advance (booking window)', min: 1, max: 1095, default: 90, description: 'How far ahead a booking can be placed. The storefront search caps the date pickers here. ~90 = 3 months.' },
        { kind: 'number', key: 'min_day_stays', label: 'Min rental duration (days)', min: 0, max: 365 },
        { kind: 'number', key: 'max_day_stays', label: 'Max rental duration (days)', min: 0, max: 365 },
      ],
    },
    {
      label: 'Cancellation',
      fields: [
        { kind: 'select', key: 'cancellation_policy', label: 'Default cancellation policy', default: 'flexible', options: [
          { value: 'flexible', label: 'Flexible (free up to 24h before)' },
          { value: 'moderate', label: 'Moderate (50% refund up to 24h before)' },
          { value: 'strict', label: 'Strict (no refund within 7 days)' },
          { value: 'non_refundable', label: 'Non-refundable' },
        ] },
        { kind: 'number', key: 'free_cancellation_hours', label: 'Free cancellation window (hours)', min: 0, max: 720, default: 24 },
      ],
    },
  ],
};
